import * as HttpStatusCodes from "../../constants/HttpStatusCodes";

export const COALESCED_ERROR_CODES = [
  HttpStatusCodes.UNAUTHORIZED,
  HttpStatusCodes.FORBIDDEN,
  HttpStatusCodes.NOT_FOUND,
];
